import { SITE } from "@/config/site";
import { Pending } from "./Primitives";

// Florida s. 496.411(3) solicitation disclosure. Shown wherever donations are requested.
export const FloridaDisclosure = ({ dark = false, className = "", testId = "florida-disclosure" }) => {
  const reg = SITE.nonprofit.stateRegistration;
  if (!reg) return <Pending label="Florida registration disclosure" dark={dark} />;
  const link = dark ? "text-paper underline underline-offset-2" : "text-navy underline underline-offset-2";
  return (
    <p className={`text-xs leading-relaxed ${dark ? "text-[#AFBFCE]" : "text-ink/75"} ${className}`} data-testid={testId}>
      {SITE.name} is registered with the Florida Department of Agriculture and Consumer Services, registration number {reg}.{" "}
      A COPY OF THE OFFICIAL REGISTRATION AND FINANCIAL INFORMATION MAY BE OBTAINED FROM THE DIVISION OF CONSUMER SERVICES BY CALLING TOLL-FREE{" "}
      (<a href="tel:+18004357352" className={link}>1-800-HELP-FLA / 1-800-435-7352</a>) WITHIN THE STATE OR VISITING{" "}
      <a href="https://www.fdacs.gov" target="_blank" rel="noopener noreferrer" className={link}>FDACS.gov</a>.{" "}
      REGISTRATION DOES NOT IMPLY ENDORSEMENT, APPROVAL, OR RECOMMENDATION BY THE STATE.
    </p>
  );
};
